import React from "react";
import { Box, MenuItem, Separator } from "@showitinc/showit-wc";
import ContextMenuWrapper from "./ContextMenuWrapper";
import AppConstants from "../../constants/AppConstants";
import uiPrefix from "../../utils/UiPrefixUtils";
import styles from "./PagePanelElementContextMenu.module.css";

const { CONTEXT_ITEM_BUTTON, LOCK_EDITING_KEY } = AppConstants;

const PagePanelElementContextMenu = ({
  rename,
  duplicate,
  remove,
  toggleLayerLock,
  element,
  size,
  theme,
  state,
  active,
}) => (
  <ContextMenuWrapper icon="menuMoreHoriz" size={size} theme={theme} state={state} active={active}>
    <MenuItem data-e2e={uiPrefix(`rename-${CONTEXT_ITEM_BUTTON}`)} onClick={rename}>
      Rename
    </MenuItem>
    <MenuItem data-e2e={uiPrefix(`duplicate-${CONTEXT_ITEM_BUTTON}`)} onClick={duplicate}>
      Duplicate
    </MenuItem>
    <MenuItem
      data-e2e={uiPrefix(`toggle-layer-lock-${CONTEXT_ITEM_BUTTON}`)}
      onClick={toggleLayerLock}
    >
      {element.get(LOCK_EDITING_KEY) === "1" ? "Unlock" : "Lock"}
    </MenuItem>
    <Separator variant="context-menu" />
    <MenuItem data-e2e={uiPrefix(`delete-${CONTEXT_ITEM_BUTTON}`)} onClick={remove}>
      <Box className={styles.delete}>Delete</Box>
    </MenuItem>
  </ContextMenuWrapper>
);

export default PagePanelElementContextMenu;
